export default {
  apiVersion: {
    admin: 'v1.21-admin',
    public: 'v1.21-public'
  },
  statusColor: {
    cancelled: 'rejected',
    cancelledDueMissingCheckIn: 'rejected',
    checkedOut: 'waiting',
    checkedIn: 'available',
    booked: 'available',
    rejected: 'rejected',
    waitingApproval: 'pending',
    waitingCheckIn: 'pending',
    partiallyApproved: 'pending',
    partiallyRejected: 'rejected'
  },
  typeRequest: [
    { value: 'cleaning', label: 'cleaning' },
    { value: 'electrical', label: 'electrical' },
    { value: 'furniture', label: 'furniture' },
    { value: 'it', label: 'it' },
    { value: 'temperature', label: 'temperature' },
    { value: 'others', label: 'others' },
  ],
  behaviorRequest: [
    { value: 'default', label: 'email' },
    { value: 'whatsApp', label: 'whatsApp' }
  ],
  deskTypeFilterOptions: [
    { value: false, label: 'allDesks' },
    { value: true, label: 'desksWithBookings' }
  ],
  uploadStatus: {
    waiting: 'WAITING',
    uploading: 'UPLOADING',
    success: 'SUCCESS',
    error: 'ERROR',
  },
  bookingType: {
    forGuest: 'forGuest'
  },
  pinStatus: {
    removed: 'removed',
    updated: 'updated',
    inserted: 'inserted',
    none: 'none'
  },
  bookingParams: {
    defaultStartTime: '08:00',
    limitTime: '18:00',
    limitBookingEndTime: '23:00'
  },
  restaurantBookingParams: {
    maxSlots: '30'
  },
  userBookingComponent: {
    desk: 'DeskBookingCard',
    locker: 'LockerBookingCard',
    restaurant: 'RestaurantBookingCard',
    charteredBus: 'CharteredBookingCard',
    parking: 'ParkingBookingCard',
    room: 'RoomBookingCard'
  },
  tabFields: [
    {
      key: 'tab-restaurant',
      value: [
        'periodForRestaurantBooking',
        'restaurantAvailableFrom',
        'amountOfSlotsForRestaurant'
      ]
    },
    {
      key: 'tab-corporate-notice',
      value: ['corporateNoticeAdvice']
    },
    {
      key: 'tab-booking',
      value: [
        'antecedence-limit',
        'minimum-booking-limit',
        'maximum-booking-limit',
        'customDays',
        'checkinTolerance'
      ]
    },
    {
      key: 'tab-desk',
      value: [
        'limitAmountOfBookings',
        'maximum-days-restaurant-booking-limit',
        'maximum-hours-restaurant-booking-limit'
      ]
    },
    {
      key: 'tab-parking',
      value: [
        'maximum-days-parking-booking-limit',
        'maximum-hours-parking-booking-limit'
      ]
    }
  ],
  downloadFile: {
    statusProcessed: 200,
    maxTimeToWait: 180000,
    initialRetry: 0,
    initialSumTimeToWait: 2000
  },
  checkinTypes: {
    beacon: 'beacon',
    qrCode: 'qrCode',
    qrCodeAndBeacon: 'qrCodeAndBeacon'
  },
  checkInStatus: {
    cancelled: 'cancelled',
    cancelledDueMissingCheckIn: 'cancelledDueMissingCheckIn',
    checkedOut: 'checkedOut',
    checkedIn: 'checkedIn',
    booked: 'booked',
  },
  itineraryOptions: [
    { value: 'round', label: 'roundTrip' },
    { value: 'oneWay', label: 'oneWayTrip' },
    { value: 'return', label: 'returnTrip' },
  ],
  bookingLimitPeriodInDays: {
    weekly: 7,
    monthly: 31,
  },
  charteredBusBookingTripType: {
    none: 'none',
    round: 'round',
    oneWay: 'oneWay',
    return: 'return'
  },
  charteredTripTypeKey: {
    round: 'roundTrip',
    oneWay: 'oneWayTrip',
    return: 'returnTrip'
  },
  charteredComponentKey: {
    round: 'chartered-round-trip',
    oneWay: 'chartered-one-way-trip',
    return: 'chartered-return-trip'
  },
  filterOptionsBoookings: [
    {
      id: 0,
      name: 'desk'
    },
    {
      id: 1,
      name: 'room'
    },
    {
      id: 2,
      name: 'restaurant'
    },
    {
      id: 3,
      name: 'charteredBus'
    },
    {
      id: 4,
      name: 'parking'
    },
    {
      id: 5,
      name: 'locker'
    }
  ],
  bookingTypeEnum: {
    'desk': 0,
    'room': 1,
    'restaurant': 2,
    'charteredBus': 3,
    'parking': 4,
    'locker': 5
  },
  deviceIcon: {
    tablet: 'tablet',
    sensor: 'settings_remote',
    beacon: 'bluetooth'
  },
  recurrences: {
    notRepeat: 'notRepeat',
    daily: 'daily',
    weekly: 'weekly',
    none: 'none'
  },
  typeOptions: [
    {
      id: "notRepeat",
      name: "notRepeat"
    },
    {
      id: "daily",
      name: "daily"
    },
    {
      id: "weekly",
      name: "weekly"
    }
  ],
  weekDayOptions: {
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    7: 'sunday'
  },
  bookingStatus: {
    restriction: [
      { value: 'active', label: 'active' },
      { value: 'inactive', label: 'inactive' },
    ]
  },
  unbookedEntranceOptions: [
    { value: 'desk', label: 'desk' },
    { value: 'charteredBus', label: 'charteredBus' },
    { value: 'restaurant', label: 'restaurant' },
  ],
  uiConfig: {
    hasContactForm: true,
    culture: 'portuguese'
  },
  primaryColor: '#0d47a1',
  accentColor: '#fdd835',
  roomStatusColor: {
    isApproved: 'md-primary',
    eventsNeedApproval: 'md-pending',
    rejected: 'md-rejected'
  },
  serviceDeskStatus: {
    waiting: 'waiting',
    approved: 'approved',
    rejected: 'rejected',
    partiallyApproved: 'partiallyApproved',
    partiallyRejected: 'partiallyRejected',
    notAssigned: 'notAssigned'
  },
  serviceDeskStatusColor: {
    waiting: 'md-pending',
    approved: 'md-primary',
    rejected: 'md-rejected',
    partiallyApproved: 'md-pending',
    partiallyRejected: 'md-pending',
    notAssigned: 'md-pending'
  },
  serviceDeskStatusText: {
    waiting: 'waitingBySupplier',
    approved: 'approvedBySupplier',
    rejected: 'rejectedBySupplier',
    partiallyApproved: 'partiallyApprovedBySupplier',
    partiallyRejected: 'partiallyRejectedBySupplier',
    notAssigned: 'notAssigned'
  },
  roomStatusText: {
    ok: 'booked',
    waitingApproval: 'waitingApproval',
    partiallyApproved: 'partiallyApproved',
    rejected: 'rejected',
    partiallyRejected: 'partiallyRejected',
    waitingCheckIn: 'booked',
    checkedIn: 'checkedIn',
    pending: 'pending'
  },
  roomStatusKey: {
    ok: 'ok',
    waitingApproval: 'waitingApproval',
    rejected: 'rejected',
    waitingCheckIn: 'waitingCheckIn',
    checkedIn: 'checkedIn'
  },
  notificationGroupType: {
    serviceDesk: 'serviceDesk',
    eventApproval: 'eventApproval'
  },
  employeeGroupExportLimit: 20000,
  employeeGroupEditLimit: 10000,
  colabAddedLimit: 100,
  eventTypes: [
    {
      id: '1',
      name: 'eventTypeOther'
    },
    {
      id: '2',
      name: 'eventTypeBrokersLunch'
    },
    {
      id: '3',
      name: 'eventTypeConsortiumAssembly'
    },
    {
      id: '4',
      name: 'eventTypeChristmasDinner'
    },
    {
      id: '5',
      name: 'eventTypeHrCourse'
    },
    {
      id: '6',
      name: 'eventTypeExternalEvent'
    },
    {
      id: '7',
      name: 'eventTypeLecture'
    },
    {
      id: '8',
      name: 'eventTypeBrokersMeeting'
    },
    {
      id: '9',
      name: 'eventTypeCollaboratorsMeeting'
    },
    {
      id: '10',
      name: 'eventTypeProvidersMeeting'
    },
    {
      id: '11',
      name: 'eventTypeCollaboratorsTraining'
    },
    {
      id: '12',
      name: 'eventTypeProvidersTraining'
    },
    {
      id: '13',
      name: 'eventTypeBrokersTraining'
    },
    {
      id: '14',
      name: 'eventTypeWorkshop'
    }
  ],
  meetingProviderTypes: [
    {
      calendar: 'googleCalendar',
      types: [
        {
          name: 'googleMeet',
          isNecessaryKey: false,
          isDefaultMeet: true
        },
        {
          name: 'zoom',
          isNecessaryKey: true
        }
      ],
      calendarName: 'Google Calendar'
    },
    {
      calendar: 'microsoftCalendar',
      types: [
        {
          name: 'microsoftTeams',
          isNecessaryKey: false,
          isDefaultMeet: true
        }
      ],
      calendarName: 'Microsoft Calendar'
    },
    {
      calendar: 'exchangeOnPremises',
      calendarName: 'Exchange OnPremises Calendar'
    },
  ],
  typeLocationIntegration: [
    {
      type: 'invenzi',
      name: 'Invenzi (W-Access)'
    }
  ],
  measureTypes: [
    'sound',
    'light',
    'humidity',
    'temperature',
    'airQuality'
  ],
  iconType: {
    'sound': 'hearing',
    'light': 'light_mode',
    'humidity': 'water_drop',
    'temperature': 'device_thermostat',
    'airQuality': 'air'
  },
  removeClientDefaultDaysAhead: 7,
  removeClientMaxDaysAhead: 30,
  alertTimeParams: {
    defaultStartTime: '08:00',
    defaultFinishTime: '18:00',
  },
  clientTiers: {
    tierOne: 'Tier 1',
    tierTwo: 'Tier 2',
    tierThree: 'Tier 3'
  },
  weekDays: {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
  },
  colabAddedTeamLimit: 9,
  maxSearchTeam: 60,
  minSearchTeam: 30,
  paginationStatus: {
    load: 'load',
    end: 'end',
    wait: 'wait'
  },
  inviteStatus: {
    noReply: 'noReply',
    accepted: 'accepted',
    refused: 'refused'
  },
  inviteDetailStatusLimit: 100,
  invitedsPaginatedHeight: 156,
  interestZonesLimit: 5,
  featureFlags: {
    meal: 'Meal',
    gadgets: 'Gadgets',
    inviteTeam: 'InviteTeam',
    neoAccess: 'NeoAccess',
    neoAi: 'NeoAi',
  },
  space2CheckReportDefaultStartTime: '08:00:00',
  space2CheckReportDefaultEndTime: '18:00:00',
  twelveHourCalendarFormat: 12,
  twentyFourHourCalendarFormat: 24,
  space2CheckReportAggregationFilter: [
    { value: 'average', label: 'average' },
    { value: 'peak', label: 'peak' }
  ],
  calculationType: {
    average: 'average',
    peak: 'peak'
  },
  chartLegendPosition: {
    top: 'top',
    left: 'left',
    bottom: 'bottom',
    right: 'right',
    chartArea: 'chartArea'
  },
  chartLegendAlign: {
    start: 'start',
    center: 'center',
    end: 'end',
  },
  featuresMapPointType: {
    free: 'free',
    booked: 'booked',
    checkedin: 'checkedin',
    busy: 'busy',
    selected: 'selected',
    blocked: 'blocked',
    polygon: 'polygon'
  },
  offsetHeight: 240,
  toolbarHeight: 64,
  culture: {
    pt: 1,
    en: 2,
    es: 3
  },
  spacesType: {
    all: 'all',
    rooms: 'rooms'
  },
  chartLineAnnotationValue: 85,
  indicatorPeriodsType: {
    perDay: 'perDay',
    perHour: 'perHour'
  },
  journeyTypes: [
    {
      id: 1,
      name: 'desks'
    },
    {
      id: 2,
      name: 'rooms'
    },
    {
      id: 3,
      name: 'restaurants'
    },
    {
      id: 4,
      name: 'parkings'
    },
    {
      id: 5,
      name: 'charteredBuses'
    }
  ]
}
